import { BuildTwoTone, LayoutTwoTone } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "redux/store";
import Typography from "style-guide/component/Typography";
import Loading from "style-guide/component/Loader";

interface OptionProps {
  icon: React.ReactNode;
  text: string;
  onClick?: () => void;
}

const OptionCard: React.FC<OptionProps> = ({ icon, text, onClick }) => (
  <div
    className="w-full sm:w-[250px] md:w-[350px] border-[1px] border-[#D9D9D9] gap-4 md:gap-10 rounded-lg p-6 flex flex-col justify-between hover:border-blue-primary cursor-pointer"
    onClick={onClick}
  >
    {icon}
    <Typography variant="LG" text={text} />
  </div>
);

const LandingPage: React.FC = () => {
  const navigate = useNavigate();

  const { userProfile, isLoading } = useSelector(
    (state: RootState) => state.applicationData
  );
  const userVertical = userProfile?.userDetails[0]?.vertical;

  const handleNavigate = (url: string) => {
    localStorage.clear();
    document.cookie = "rfp_id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    navigate(url);
  };

  const handleNavigateWithCheck = (url: string) => {
      handleNavigate(url);
  };

  if (isLoading) {
    return <Loading />;
  }

  const rfpOptions: OptionProps[] = [
    {
      icon: (
        <BuildTwoTone twoToneColor="#0F428D" style={{ fontSize: "40px" }} />
      ),
      text: "Generate new RFP requirements",
      onClick: () => handleNavigateWithCheck("/build-scratch"),
    },
    {
      icon: (
        <LayoutTwoTone twoToneColor="#0F428D" style={{ fontSize: "40px" }} />
      ),
      text: "Analyze RFP vendor responses",
      onClick: () => handleNavigateWithCheck("/rfp-defined"),
    },
  ];

  const hrOptions: OptionProps[] = [
    {
      icon: (
        <BuildTwoTone twoToneColor="#0F428D" style={{ fontSize: "40px" }} />
      ),
      text: "Analyze Job Applicants",
      onClick: () => handleNavigateWithCheck("/analyze-job"),
    },
  ];

  return (
    <div className="w-full p-4 sm:p-6 md:p-12 font-helvetica-neue flex flex-col gap-8 sm:gap-8">
      <div className="bg-pink gap-2 flex flex-col justify-between rounded-md">
        <Typography
          text="How do you want to get started?"
          variant="Heading 3"
          className="text-black text-lg sm:text-xl md:text-2xl"
        />
        <Typography
          text="Pick an option."
          variant="LG"
          className="text-black"
        />
      </div>
      <div className="w-full flex flex-col md:flex-row gap-4 items-center md:items-stretch">
        {userVertical === "rfp"
          ? rfpOptions.map((option, index) => (
              <OptionCard
                key={index}
                icon={option.icon}
                text={option.text}
                onClick={option.onClick}
              />
            ))
          : hrOptions.map((option, index) => (
              <OptionCard
                key={index}
                icon={option.icon}
                text={option.text}
                onClick={option.onClick}
              />
            ))}
      </div>
    </div>
  );
};

export default LandingPage;
